// KEYCLOAK_URL

import axios from "axios";

import dayjs from "dayjs";
import config from "../../../config";

const POSTREST_URL = config.POSTREST_URL;


export async function fetchGovAccident() {
  const displayMessage = (d) => {
    if (!d) return;
    const description = d.description ? d.description : "";
    const date = d.fetcheddate ? dayjs(d.fetcheddate).format("DD/MM/YYYY") : "";

    const message = `<div>
        <p>${description}</p>     
        <p>${date}</p>
      </div>`;

    return message;
  };

  try {
    const response = await axios.get(`${POSTREST_URL}/accidents_gov`, {
      headers: {
        "Content-Type": "application/json",
        "accept-profile": "map",
      },
    });

    const features = response.data.map((data, index) => ({
      id: 10000 + (index + 1),
      type: "Feature",
      properties: {
        id: data.id,
        id_island: data.id_island,
        date: dayjs(data.fetcheddate).format("DD/MM/YYYY HH:mm"),
        displayMessage: displayMessage(data),
      },
      geometry: {
        type: "Point",
        coordinates: [data.gpsx, data.gpsy],
      },
    }));

    return {
      type: "FeatureCollection",
      features,
    };
  } catch (error) {
    console.error("Error fetching form fields:", error);
    return { data: null, error: error.message || "Unknown error" };
  }

 
}

// function convertToObject(response) {
//     const features = response.map((data) => ({
//         id: data.id,
//         type: "Feature",
//         properties: {
//             id_island: data.id_island,
//             displayMessage: data.description,
//         },
//         geometry: {
//             type: "Point",
//             coordinates: [data.gpsy, data.gpsx],
//         },
//     }));

//     return features;
// }
